import React from "react";
import "../styles/Hero.css";
import { CardBody, CardContainer, CardItem } from "../aceternity/ui/3d-card";
import image1 from "../temp_assets/temp1.png";
import image2 from "../temp_assets/temp2.png";
import image3 from "../temp_assets/temp3.png";
import image4 from "../temp_assets/temp4.png";
import image5 from "../temp_assets/temp5.png";
const cardItems = [
  { id: 1, title: "Stylish Designs", image: image5 },
  { id: 2, title: "Trendy Outfits", image: "./assets/hero2.jpeg" },
  { id: 3, title: "Premium Fashion", image: image1 },
  { id: 4, title: "Elegant Styles", image: image2 },
  { id: 5, title: "Stylish Designs", image: "./assets/hero1.jpeg" },
  { id: 6, title: "Trendy Outfits", image: "./assets/hero2.jpeg" },
  { id: 7, title: "Premium Fashion", image: image3 },
  { id: 8, title: "Elegant Styles", image: image4 },
];

function InfiniteMovingCards() {
  return (
    <div className="overflow-x-hidden w-[90%] bg-gray-100 h-[fit-content] mx-10 mt-40 mb-40">
      {/* Animated Container */}
      <div className="flex animate-scroll gap-4">
        {/* Cards (Original + Duplicate for continuous effect) */}
        {[...cardItems, ...cardItems].map((item, index) => (
          <div key={index} className="w-80 flex-shrink-0">
            <CardContainer className="w-full">
              <CardBody className="relative rounded-xl bg-white shadow-2xl p-6 border border-gray-200 h-[fit-content] pb-[2rem]">
                <CardItem translateZ="100" className="w-full mt-4">
                  <img
                    src={item.image}
                    className="h-80 w-full object-cover rounded-xl"
                    alt={item.title}
                  />
                </CardItem>
                <CardItem
                  translateZ="50"
                  className="text-xl text-neutral-600 dark:text-black mt-2"
                >
                  {item.title}
                </CardItem>
              </CardBody>
            </CardContainer>
          </div>
        ))}
      </div>
    </div>
  );
}

export default InfiniteMovingCards;
